import React from "react";
export const LocalizationContext = React.createContext({});
LocalizationContext.displayName = "LocalizationContext";
export const LocalizationProvider = ({ children, country: defaultCountry, detectLocale = true, market: defaultMarket, mode, }) => {
    const [country, setCountry] = React.useState(defaultCountry);
    const [market, setMarket] = React.useState(defaultMarket);
    const getCookie = (key) => {
        const b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
        return b ? b.pop() : "";
    };
    React.useEffect(() => {
        if (!detectLocale)
            return;
        const country = getCookie("cm-country");
        const market = getCookie("cm-market");
        if (country)
            setCountry(country);
        if (market)
            setMarket(market);
    }, [detectLocale]);
    return (React.createElement(LocalizationContext.Provider, { value: { country, market, mode } }, children));
};
//# sourceMappingURL=context.js.map